import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LucideAngularModule, ChefHat, Truck, Award, Heart, Clock, Users, ArrowRight } from 'lucide-angular';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CartService } from '../../services/cart.service';
import { companyInfo, restaurants } from '../../data/mock';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent, FooterComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent implements OnInit, OnDestroy {
  companyInfo = companyInfo;
  featuredRestaurants = restaurants.slice(0, 4);
  cartCount = 0;
  private cartSubscription!: Subscription;

  features = [
    { icon: 'chef-hat', title: '14 Premium Restaurants', description: 'Curated selection of the finest cloud kitchens, each specializing in unique cuisines.' },
    { icon: 'truck', title: 'Zero Delivery Fee', description: 'Enjoy free delivery on all orders with no minimum order value.' },
    { icon: 'award', title: 'Bulk Order Always', description: 'Get flat 30% discount on every order, no coupon hunting required.' },
    { icon: 'heart', title: 'Quality Assured', description: 'Every kitchen follows strict hygiene standards and uses premium ingredients.' },
    { icon: 'clock', title: 'Lightning Fast Delivery', description: 'Average delivery time of just 30 minutes to your doorstep.' },
    { icon: 'users', title: '1M+ Happy Customers', description: 'Join over a million satisfied food lovers who trust Capital Food.' }
  ];

  constructor(private cartService: CartService) { }

  ngOnInit() {
    this.cartSubscription = this.cartService.cart$.subscribe(() => {
      this.cartCount = this.cartService.getCartCount();
    });
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }
}
